import React from 'react';
import { useTranslation } from 'react-i18next';
import HeaderTour from '../TourDropDownList/HeaderTour';
import './HeaderTour.scss';
var TourDropDownList = function (_a) {
    var tourDropdownActiveState = _a.tourDropdownActiveState, setTourDropdownActiveState = _a.setTourDropdownActiveState, tours = _a.tours;
    var t = useTranslation().t;
    var hideOtherDropdowns = function () {
        setTourDropdownActiveState(!tourDropdownActiveState);
    };
    return (React.createElement("li", { className: "sdds-nav__item sdds-nav__dropdown ".concat(tourDropdownActiveState ? "sdds-nav__dropdown--opened" : '') },
        React.createElement("button", { className: 'sdds-nav__item-core', onClick: function () { return hideOtherDropdowns(); } },
            React.createElement("p", { className: 'sdds-nav__item-core-text' }, t("TS_core:StartTour"))),
        React.createElement("ul", { className: 'sdds-nav__dropdown-menu' },
            React.createElement("li", { className: 'sdds-nav__dropdown-item' },
                React.createElement(HeaderTour, null)),
            tours && React.createElement("li", { className: 'sdds-nav__dropdown-item' }, tours))));
};
export default TourDropDownList;
